var _path, _ellipse, _ellipse2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackEmoji3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1867 38C76.1867 58.2136 59.6271 74.624 39.17 74.624C18.7129 74.624 2.15337 58.2136 2.15337 38C2.15337 17.7864 18.7129 1.37602 39.17 1.37602C59.6271 1.37602 76.1867 17.7864 76.1867 38Z",
    stroke: "#27ABB3",
    strokeWidth: 2.75205
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1234,
    cy: 29.6586,
    rx: 4.68203,
    ry: 4.63415,
    fill: "#27ABB3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.2172,
    cy: 29.6586,
    rx: 4.68203,
    ry: 4.63415,
    fill: "#27ABB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.126 41.7073C26.0624 44.7967 30.089 50.9756 38.7039 50.9756C47.3188 50.9756 51.6575 44.7967 52.75 41.7073",
    stroke: "#27ABB3",
    strokeWidth: 2.75205
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackEmoji3);
export default __webpack_public_path__ + "static/media/Feedback_emoji_3.20da76caa027d7c41cffc0362cadca72.svg";
export { ForwardRef as ReactComponent };